import searchGoodsApi from '@/api/auth_app/tb1688'
import { Service_GetBranchRelId } from '@/service/branch_relId_service'
import { ItemType_Tb1688 } from '@/utils/constant/item'
import { message } from 'ant-design-vue'

// 搜索1688商品通过关键词
async function StartSearchKeyword(fromData,dyItemOrderInfo,itemInfo){
  var {pageSize ,currentPage} = itemInfo
  var  {itemList,total,msg,success} = await searchGoodsApi.SearchTb1688GoodsByKeyword(fromData,currentPage,pageSize,
    Service_GetBranchRelId(dyItemOrderInfo.relation,ItemType_Tb1688.type))
  
  if(!success) {
    message.error(msg)
    return []
  }
  var newItemList = updataGoodsList(itemList)
  itemInfo.total = total
  return newItemList
}


function updataGoodsList(itemList) {
  console.log(itemList)
  debugger
  var newItemList = []
  if(itemList.length == 0) return newItemList 
  itemList.forEach(item =>{
    var newItem = {
      title: item.title,
      nid:item.itemId,
      imgUrl: item.imgUrl, 
      reservePrice: item.maxPrice / 100,
      link: `https://detail.1688.com/offer/${item.itemId}.html`,
      tejiaTotalSoldQuantity: item.salesCnt90d,
      zkFinalPrice:item.maxPrice / 100
    }
    newItemList.push(newItem)
  })
  return newItemList
}

const config = {

}


export default {StartSearchKeyword,config}